import { LitElement, html, css } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
export class SideDrawerBtn extends LitElement {
	static styles = css`
		button {
			cursor: pointer;
			background: none;
			border: none;
			padding: 0;
			display: flex;
			align-items: center;
			appearance: none;
		}

		.w-full {
			width: 100%;
		}

		.flex-1 {
			flex: 1 1 0%;
		}

		.justify-start {
			justify-content: flex-start;
		}

		.justify-end {
			justify-content: flex-end;
		}
	`;

	static properties = {
		for: { type: String, reflect: true },
		active: { type: Boolean, reflect: true },
		stretch: { type: String },
		fullWidth: { type: Boolean, attribute: 'full-width' },
	};

	constructor() {
		super();
		this.active = false;
		this._toggle = () => {
			this.active = !this.active;
		};
	}

	connectedCallback() {
		super.connectedCallback();
		this.class = '';
		if (this.stretch === 'right') {
			this.class = 'flex-1 justify-end';
		} else if (this.stretch === 'left') {
			this.class = 'flex-1 justify-start';
		}

		if (this.fullWidth) {
			this.class += ' w-full';
		}

		window.MicroBus.on(`${this.for}:toggle`, this._toggle);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		window.MicroBus.on(`${this.for}:toggle`, this._toggle);
	}

	render() {
		return html`
			<button class=${ifDefined(this.class)} @click=${this._onClick}>
				<slot></slot>
			</button>
		`;
	}

	_onClick() {
		if (this.for === 'save-side-drawer' && window?.gtag && !this.active) {
			window.gtag('event', 'Wishlist - Opened Saved Items');
		}
		window.MicroBus.emit(`${this.for}:toggle`);
	}
}
if (!customElements.get('side-drawer-btn'))
	customElements.define('side-drawer-btn', SideDrawerBtn);
